import { DatePickerWithRange } from "@/components/DatePickerWithRange";
import { observer } from "mobx-react-lite";
import { DateRange } from "react-day-picker";
import { useHistoryFilters } from "./history-filter-store";

const DateRangeSelector = () => {
  const filterStore = useHistoryFilters();

  const handleDateChange = (dateRange: DateRange | undefined) => {
    filterStore.setDateRange(dateRange);
  };

  return (
    <div className="flex w-full flex-col">
      <label htmlFor="date-range" className="mb-1 block text-sm font-medium">
        Date Range
      </label>
      <DatePickerWithRange
        date={filterStore.selectedDateRange}
        setDate={handleDateChange}
      />
    </div>
  );
};

export default observer(DateRangeSelector);
